import React from "react";
import ArrowRight from "../../assets/arrow-right.svg?react";
import classnames from "classnames";
import { ButtonVariant } from "../../types/button";

interface LinkProps {
  text: string;
  href: string;
  variant?: ButtonVariant;
  className?: string;
  forceAddIcon?: boolean;
}

const getClassByVariant = (variant: ButtonVariant) => {
  switch (variant) {
    case "main":
      return "px-6 bg-primary text-md text-white  outline-none hover:bg-primaryBlue hover:border-primaryBlue hover:text-white hover:outline-none";
    case "secondary":
    case "link-primary":
      return "px-6 border-2 border-primary bg-transparent text-primary  outline-none hover:text-primaryBlue hover:border-primaryBlue hover:outline-none";
    case "link-primary-reverse":
      return "px-6 border-2 border-white bg-transparent text-white  outline-none hover:border-primaryBlue hover:text-primaryBlue hover:border-2 hover:outline-none";
    case "link-secondary":
      return "text-primary hover:text-primaryBlue border-0 outline-none hover:border-none hover:outline-none";
    case "text":
      return "text-primary hover:text-primaryBlue ";
    case "link-secondary-reverse":
      return "text-white border-none  hover:text-primaryBlue hover:border-none hover:outline-none";
    case "main-reverse":
      return "px-6 bg-white text-primary hover:bg-primaryBlue hover:text-white  border-white outline-white border-white hover:outline-primaryBlue hover:border-primaryBlue";
    default:
      return "bg-primary text-white ";
  }
};

const typesWithIcons = [
  "link-primary",
  "link-secondary",
  "link-primary-reverse",
  "link-secondary-reverse",
];

export const Link: React.FC<LinkProps> = ({
  variant = "main",
  href,
  text,
  className,
  forceAddIcon = false,
}) => {
  const shouldUseIcon = forceAddIcon ? forceAddIcon : typesWithIcons.includes(variant);

  return (
    <a
      className={classnames(
        getClassByVariant(variant),
        "leading-9 rounded flex items-center group",
        className
      )}
      href={href}
    >
      {text}
      {shouldUseIcon && (
        <span className="ml-2 group-hover:translate-x-2 transition-all ease-out">
          <ArrowRight />
        </span>
      )}
    </a>
  );
};

export default Link;
